<div class="summary-container">
  <!-- Top Information Table -->
  <div class="profile-info-wrapper">
    <!-- Profile Section -->
    <!-- <div class="profile-section">
      <div class="profile-picture">
        <img src="placeholder_profile.png" alt="Profile Picture" />
      </div>
      <div class="name-container">
        <p class="name">
          {{ profileInfo?.data?.donor?.firstName }} {{ profileInfo?.data?.donor?.lastName }}
        </p>
        <div
          class="status-badge"
          [ngClass]="{
            'not-started':
              mrbSectionStatus === 'Not Started' || mrbSectionStatus === '',
            'not-scheduled': mrbSectionStatus === 'Not Scheduled',
            'in-progress': mrbSectionStatus === 'In Progress',
            'under-review': mrbSectionStatus === 'Under Review',
            scheduled: mrbSectionStatus === 'Scheduled',
            completed: mrbSectionStatus === 'Completed',
            denied: mrbSectionStatus === 'Denied',
            approved: mrbSectionStatus === 'Approved',
          }"
        >
          {{ mrbSectionStatus ? mrbSectionStatus : "Not Started" }}
        </div>
      </div>
    </div> -->

    <div class="profile-table">
      <!-- Top Information Table -->
    <app-profile-table
      [profileInfo]="profileInfo"
      [metrics]="metrics"
      [showEditButton]="false"
      [isMrbView]="true"
      class="mrb-profile-table"
    ></app-profile-table>
    </div>

    
  </div>

  <!-- Main Content Section -->
  <div class="summary-content">
    <!-- Left Panel: Blood Test Results -->
    <div class="blood-tests">
      <div class="table-container">
        <div class="blood-test-heading"><h5>Lab Results</h5></div>

      <table class="lab-results-table">
        <tbody>
          @for (test of labResults; track test) {
            <tr>
              <td>{{ test.name }}</td>
              @if (isObject(test.value)) {
                @if (test === labResults[0]) {
                  <!-- Ensure headers are added only once -->
                  <td *ngFor="let key of objectKeys(test.value)">
                    <strong>{{ key }}</strong>
                  </td>
                }
                <td *ngFor="let key of objectKeys(test.value)">
                  {{ test.value[key] }}
                </td>
              } @else {
                <td>{{ test.value }}</td>
                <td></td>
              }
            </tr>
          }
        </tbody>
      </table>
      </div>
      
    </div>

    <!-- Right Panel: Combined Notes -->
    <div class="notes-container">
      @if (isLoading) {
        <div class="notes-section">
          <div class="loading-spinner">
            <div class="spinner-border text-primary" role="status"></div>
            <p>Loading notes...</p>
          </div>
        </div>
      } @else {
        @for (section of journeySections; track section) {
          @if (section.isShareableToMRB) {
            <div class="notes-section">
              <h3 class="note-heading">{{ section.title }}</h3>

              <div class="status-container">
                <button class="view-notes-btn" (click)="viewNotes(section)">
                  View Notes
                </button>
                <div
                  class="status-badge"
                  [ngClass]="{
                    'not-started': section.currentStatus === 'Not Started',
                    'not-scheduled': section.currentStatus === 'Not Scheduled',
                    'in-progress': section.currentStatus === 'In Progress',
                    'under-review': section.currentStatus === 'Under Review',
                    scheduled: section.currentStatus === 'Scheduled',
                    completed: section.currentStatus === 'Completed',
                    denied: section.currentStatus === 'Denied',
                    approved: section.currentStatus === 'Approved',
                  }"
                >
                  {{ section.currentStatus }}
                </div>
              </div>
              @if (getSummaryNote(section.notes)) {
                <div class="ql-wrapper">
                  <quill-view
                    [content]="getSummaryNote(section.notes)"
                    theme="snow"
                  ></quill-view>
                </div>
              } @else {
                <p class="no-summary-text">No summary added yet</p>
              }
            </div>
          }
        }
      }
    </div>
  </div>

  <!-- Export to PDF Button -->
  <!-- <button class="btn btn-primary export-btn" (click)="exportToPDF()">
    Export to PDF
  </button> -->
</div>
